module.exports = __webpack_public_path__ + "static/CalculatedField-3883f536ab72b5a585ee462cedaf2822.gif";